import React, { FC, memo } from "react";
import Icon from "components/Icon/Icon";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import { DeleteButton } from "../CustomDeclarationV2.styles";

interface DeleteRowButtonProps {
  onClick: () => void;
}

const DeleteRowButton: FC<DeleteRowButtonProps> = ({ onClick }) => {
  const { t } = useTranslation("common");

  return (
    <DeleteButton
      aria-label={t("common.remove")}
      title={t("common.remove")}
      onClick={onClick}
      tabIndex={-1}
    >
      <Icon type={IconType.Delete} />
    </DeleteButton>
  );
};

export default memo(DeleteRowButton);
